import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPublicTournamentJoinInvite, requestTournamentJoinOtp, verifyTournamentJoinOtp } from '../../../services/tournamentService';

const TOURNAMENT_ROLE_OPTIONS = ['Player', 'Scorer', 'Umpire', 'Match Referee'];

export default function JoinTournamentPage() {
  const { token } = useParams();
  const [invite, setInvite] = useState(null);
  const [form, setForm] = useState({ email: '', mobile: '', otp: '' });
  const [tournamentRoles, setTournamentRoles] = useState(['Player']);
  const [step, setStep] = useState('contact');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    getPublicTournamentJoinInvite(token).then(setInvite).catch((e) => setMsg(e.message));
  }, [token]);

  const toggleTournamentRole = (role) => {
    setTournamentRoles((current) => (current.includes(role) ? current.filter((item) => item !== role) : [...current, role]));
  };

  const reqOtp = async () => {
    if (!form.email.trim() && !form.mobile.trim()) {
      setMsg('Enter email or mobile number to receive OTP.');
      return;
    }
    const response = await requestTournamentJoinOtp({ inviteToken: token, email: form.email, mobile: form.mobile });
    if (Array.isArray(response.defaultTournamentRoles)) {
      setTournamentRoles(response.defaultTournamentRoles);
    }
    setStep('verify');
  };

  const verify = async () => {
    const r = await verifyTournamentJoinOtp({ inviteToken: token, ...form, tournamentRoles });
    setMsg(r.requiresSignup ? r.message : 'You have joined tournament');
  };

  return (
    <div className="container py-4">
      <h3>Join Tournament</h3>
      <p>{invite?.tournament?.name || ''}</p>
      <input placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
      <input placeholder="Mobile" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} />
      <p className="text-muted">Enter email or mobile number to receive OTP.</p>
      <section className="my-3">
        <h5>Tournament Roles</h5>
        <p className="text-muted mb-2">Select the roles you are available for in this tournament.</p>
        {TOURNAMENT_ROLE_OPTIONS.map((role) => (
          <label key={role} className="d-block">
            <input type="checkbox" checked={tournamentRoles.includes(role)} onChange={() => toggleTournamentRole(role)} /> {role}
          </label>
        ))}
      </section>
      {step === 'contact' ? (
        <button onClick={reqOtp} disabled={!form.email.trim() && !form.mobile.trim()}>Request OTP</button>
      ) : (
        <>
          <input placeholder="OTP" value={form.otp} onChange={(e) => setForm({ ...form, otp: e.target.value })} />
          <button onClick={verify}>Verify</button>
        </>
      )}
      <p>{msg}</p>
    </div>
  );
}
